 
import {UserTypeEnum} from '../enums/UserTypeEnum';

export class RegisterModel {
    
    public country: string;
    public countryPrefix: string;
    public mobile: string;
    public email: string;
    public firstName: string;
    public lastName: string;
    public companyCode: string;
    public companyName: string;
    public otpCode: string;
    public userType: UserTypeEnum;
    constructor(init?:Partial<RegisterModel>) {
        
        Object.assign(this, init);
    }
}



// WEBPACK FOOTER //
// ./models/RegisterModel.ts